import React from 'react';
export const CFIconChevronsDown = {
    alias: 'chevrons-down',
    defaultTitle: 'ChevronsDown',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M12 12a.995.995 0 0 1-.64-.232l-6-5a1 1 0 0 1 1.28-1.536l5.37 4.475 5.362-4.314a1 1 0 0 1 1.255 1.558l-6 4.828a1 1 0 0 1-.628.22Zm.011 4.707 5.362-4.315a1.002 1.002 0 0 1 1.406.152c.346.43.278 1.06-.152 1.407l-6 4.828a.999.999 0 0 1-1.267-.012l-6-5a1 1 0 1 1 1.28-1.536l5.371 4.476Z' }))),
};
